import { render } from "./LoanComponent.vue?vue&type=template&id=39e5fc52"
import script from "./LoanComponent.vue?vue&type=script&lang=js"
export * from "./LoanComponent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__